import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HorizontalScrollComponent, TitleSummaryComponent } from '@client-monorepo/common/ui-components';
import { FrequentServicesPreviewComponent } from '../frequent-services-preview/frequent-services-preview.component';
import { rangeCreator } from '@client-monorepo/common/utilities';
import { AppServiceCategoryInterface, FrequentServiceInterface } from '@client-monorepo/common/service-data';

@Component({
  selector: 'common-app-services-grouped-app-services',
  standalone: true,
  imports: [CommonModule, TitleSummaryComponent, HorizontalScrollComponent, FrequentServicesPreviewComponent],
  templateUrl: './grouped-app-services.component.html',
  styleUrl: './grouped-app-services.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupedAppServicesComponent {
  category = input.required<AppServiceCategoryInterface>();
  services = input.required<Array<FrequentServiceInterface>>();
  clickOnService = output<FrequentServiceInterface>();
  isLoading = input<boolean>(false);
  rangeCreator = rangeCreator;
  filteredServices = computed(() => {
    return this.services()
      .filter((service) => {
        return service.categories ? service.categories.some((category) => category.name === this.category().name) : false;
      })
      .map((service) => {
        return { ...service, selected: false };
      });
  });

  handleClickOnService(service: FrequentServiceInterface): void {
    this.clickOnService.emit(service);
  }
}
